import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api/axios";
import { Link } from "react-router-dom";

export default function SingleCategoryPage() {
  const { id } = useParams(); // category ID from route
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState(null);

  const token = localStorage.getItem("token") || "";
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`/products`);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [id]);
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(`/categories`);
        setCategory(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategory();
  }, [id]);

  const handleAddToCart = async (productId) => {
    if (!token) {
      // ✅ Guest user → localStorage cart
      let cart = JSON.parse(localStorage.getItem("cart")) || [];
      const existingIndex = cart.findIndex((item) => item.product_id === productId);

      if (existingIndex >= 0) {
        // already in cart → increase quantity
        cart[existingIndex].quantity += 1;
      } else {
        // add new product
        const product = products.find((p) => p.id === productId);
        if (product) {
          cart.push({
            product_id: product.id,
            name: product.name,
            price: product.price,
            image: product.image_url,
            quantity: 1,
          });
        }
      }

      localStorage.setItem("cart", JSON.stringify(cart));
      alert("✅ Added to cart (Guest)!");
      window.location.reload();
      return;
    }

    // ✅ Logged-in user → backend cart
    try {
      await axios.post(
        "https://cartbackend.wsdstech.com/api/cart",
        { product_id: productId, quantity: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("Added to cart successfully!");
      window.location.reload();
    } catch (err) {
      alert("❌ Error: " + (err.response?.data?.message || "Something went wrong"));
    }
  };

  if (loading) return <p className="text-center">Loading...</p>;

  return (
    category?(
    <div className="container my-4">
      <h2 className="mb-4 text-center">{category.filter((cat) => cat.id === parseInt(id)).map((cat) => cat.name)}</h2>
      {products.length === 0 ? (
        <p className="text-center text-muted">No products in this category.</p>
      ) : (
        <div className="row">
          {products
            .filter((product) => product.subcategory_id === parseInt(id))
            .map((product) => (
              <div className="col-md-4 mb-3" key={product.id}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={product.image_url || "https://via.placeholder.com/200"}
                    className="card-img-top"
                    alt={product.name}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{product.name}</h5>
                    <p className="card-text text-muted">₹{product.price}</p>
                    <Link to={`/product/${product.id}`} className="btn btn-outline-primary w-100 mb-2">
                      🔍 View Details
                    </Link>
                      
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>):(<div className="container my-4">
      <h2 className="mb-4 text-center">Category not found</h2>
    </div>)
  );
}
